import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4bc198e5&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4bc198e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc198e5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MenuListTopFranchiseTile: require('/home/circleci/repo/components/menu/MenuListTopFranchiseTile.vue').default,Loader: require('/home/circleci/repo/components/Loader.vue').default})
